// extracted by mini-css-extract-plugin
export default {"wraaper":"NotFound_wraaper__ZzJje"};